import type { DetectionProfile } from '../core/types';

export const genericFixedWingProfile: DetectionProfile = {
  id: 'generic-fixed-wing',
  version: '1.0.0',
  label: 'Generic Fixed-Wing Demonstration',
  description:
    'Synthetic, illustrative fixed-wing telemetry profile. Not approved for operational use.',
  synthetic: true,
  dataClassification: 'SYNTHETIC_UNCLASSIFIED',
  platformCategory: 'generic-fixed-wing',
  expectedCadenceMs: 1_000,
  cadenceToleranceMs: 250,
  staleAfterMs: 5_000,
  sequencePolicy: 'required',
  channels: {
    altitude: {
      channel: 'altitude',
      label: 'Altitude',
      unit: 'ft',
      required: true,
      minimum: 0,
      maximum: 50_000,
    },
    airspeed: {
      channel: 'airspeed',
      label: 'Airspeed',
      unit: 'kts',
      required: true,
      minimum: 0,
      maximum: 650,
    },
    fuel: { channel: 'fuel', label: 'Fuel', unit: '%', required: true, minimum: 0, maximum: 100 },
    verticalRate: {
      channel: 'verticalRate',
      label: 'Vertical Rate',
      unit: 'ft/min',
      required: true,
      minimum: -8_000,
      maximum: 8_000,
    },
  },
  rules: [
    {
      id: 'fixed.range.altitude',
      kind: 'range',
      label: 'Altitude range',
      description: 'Synthetic demonstration range.',
      severity: 'error',
      enabled: true,
      channel: 'altitude',
      minimum: 0,
      maximum: 50_000,
    },
    {
      id: 'fixed.range.airspeed',
      kind: 'range',
      label: 'Airspeed range',
      description: 'Synthetic demonstration range.',
      severity: 'error',
      enabled: true,
      channel: 'airspeed',
      minimum: 0,
      maximum: 650,
    },
    {
      id: 'fixed.range.fuel',
      kind: 'range',
      label: 'Fuel range',
      description: 'Synthetic demonstration range.',
      severity: 'error',
      enabled: true,
      channel: 'fuel',
      minimum: 0,
      maximum: 100,
    },
    {
      id: 'fixed.range.vertical-rate',
      kind: 'range',
      label: 'Vertical-rate range',
      description: 'Synthetic demonstration range.',
      severity: 'error',
      enabled: true,
      channel: 'verticalRate',
      minimum: -8_000,
      maximum: 8_000,
    },
    {
      id: 'fixed.rate.altitude',
      kind: 'rate',
      label: 'Altitude rate',
      description: 'Time-based change check.',
      severity: 'warning',
      enabled: true,
      channel: 'altitude',
      maximumAbsoluteRate: 250,
    },
    {
      id: 'fixed.rate.airspeed',
      kind: 'rate',
      label: 'Airspeed rate',
      description: 'Time-based change check.',
      severity: 'warning',
      enabled: true,
      channel: 'airspeed',
      maximumAbsoluteRate: 25,
    },
    {
      id: 'fixed.frozen.altitude',
      kind: 'frozen',
      label: 'Frozen altitude',
      description: 'Sustained unchanged channel.',
      severity: 'warning',
      enabled: true,
      channel: 'altitude',
      minimumDurationMs: 10_000,
      tolerance: 0.01,
    },
    {
      id: 'fixed.frozen.airspeed',
      kind: 'frozen',
      label: 'Frozen airspeed',
      description: 'Sustained unchanged channel.',
      severity: 'warning',
      enabled: true,
      channel: 'airspeed',
      minimumDurationMs: 10_000,
      tolerance: 0.01,
    },
  ],
};
